<template>
  <div>
    <div
      class="modal fade"
      id="settlementInformationModal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">×</button>
            <h4 class="modal-title">
              <b>{{ lang.SET600 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <table class="table">
              <colgroup>
                <col class="col-md-4 col-xs-5" />
                <col class="col-md-8 col-xs-7" />
              </colgroup>
              <tbody>
                <tr>
                  <td>{{ lang.SET601 }}</td>
                  <td>{{ checkData.SurveyInstanceId }}</td>
                </tr>
                <tr>
                  <td>{{ lang.SET602 }}</td>
                  <td>{{ checkData.SurveyTitle }}</td>
                </tr>
                <tr>
                  <td>{{ lang.SET603 }}</td>
                  <td>{{ checkData.LocationName }}</td>
                </tr>
                <tr>
                  <td>{{ lang.SET614 }}</td>
                  <td>
                    {{ checkData.LocationAddress }} ({{
                      checkData.LocationCountry
                    }})
                  </td>
                </tr>
                <tr>
                  <td>{{ lang.SET615 }}</td>
                  <td>{{ checkData.WaveName }}</td>
                </tr>
                <tr v-if="checkData.CheckoutCreatedAt">
                  <td>{{ lang.SET604 }}</td>
                  <td>
                    {{
                      globals.getLocalizedDateTimeFromUtcIsoTimestamp(
                        checkData.CheckoutCreatedAt
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="checkData.SettlementComment">
                  <td>{{ lang.SET605 }}</td>
                  <td>{{ checkData.SettlementComment }}</td>
                </tr>

                <tr class="empty-row">
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>{{ lang.SET606 }}</td>
                  <td>
                    {{
                      globals.getCurrencyString(checkData.BasePayment, "EUR")
                    }}
                  </td>
                </tr>
                <tr v-if="checkData.PlusPayment">
                  <td>{{ lang.SET607 }}</td>
                  <td class="text-green">
                    {{
                      globals.getCurrencyString(checkData.PlusPayment, "EUR")
                    }}
                  </td>
                </tr>
                <tr v-if="checkData.MinusPayment">
                  <td>{{ lang.SET608 }}</td>
                  <td class="text-red">
                    {{
                      globals.getCurrencyString(checkData.MinusPayment, "EUR")
                    }}
                  </td>
                </tr>
                <tr class="total-background">
                  <td class="format-total-text">{{ lang.SET609 }}</td>
                  <td class="format-total-text">
                    {{ globals.getCurrencyString(checkData.Total, "EUR") }}
                  </td>
                </tr>
                <tr v-if="checkData.VatValue">
                  <td>{{ lang.SET610 }} ({{ checkData.VatRate * 100 }}%)</td>
                  <td>
                    {{ globals.getCurrencyString(checkData.VatValue, "EUR") }}
                  </td>
                </tr>
                <tr v-if="checkData.PurchaseMoney">
                  <td>{{ lang.SET611 }}</td>
                  <td>
                    {{
                      globals.getCurrencyString(checkData.PurchaseMoney, "EUR")
                    }}
                  </td>
                </tr>
                <tr class="payout-background">
                  <td class="format-total-text">{{ lang.SET612 }}</td>
                  <td class="format-total-text">
                    {{
                      globals.getCurrencyString(
                        checkData.TotalWithVatAndPurchaseMoney,
                        "EUR"
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.SET613 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettlementInformationModal",
  props: {
    showModal: { type: Boolean, default: false },
    checkData: { type: Object, default: () => {} },
  },
  data() {
    return {
      lang: {
        SET600: "Invoice Information",
        SET601: "CheckID",
        SET602: "Project",
        SET603: "Location",
        SET604: "Invoice time",
        SET605: "Comment",
        SET606: "Base payment",
        SET607: "Addition",
        SET608: "Deduction",
        SET609: "Total payment",
        SET610: "VAT",
        SET611: "Others",
        SET612: "Payout",
        SET613: "Close",
        SET614: "Address",
        SET615: "Wave",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue
        ? this.openSettlementInformationModal()
        : this.closeSettlementInformationModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#settlementInformationModal").on("hide.bs.modal", (e) => {
      this.$emit("closeModal");
    });
  },
  methods: {
    openSettlementInformationModal() {
      $("#settlementInformationModal").modal("show");
    },
    closeSettlementInformationModal() {
      $("#settlementInformationModal").modal("hide");
    },
  },
};
</script>

<style scoped>
#settlementInformationModal .modal-body {
  max-height: calc(100vh - 160px);
  overflow: auto;
}

.format-total-text {
  font-weight: bold;
}
.total-background {
  background-color: #eeeeee !important;
}
.payout-background {
  background-color: #d8d8d8 !important;
}

.modal-body > table {
  border: 1px solid rgb(238, 238, 238);
}
.modal-body > table > tbody > tr > td:last-child {
  padding-left: 20px;
  text-align: left;
}

.empty-row > td {
  height: 5px;
  padding: 0;
  background-color: #eeeeee;
}

@media (max-width: 1000px) {
  #settlementInformationModal > .modal-dialog {
    width: 100vw;
    margin: 0;
    height: calc(100vh - 160px);
  }
  #settlementInformationModal .modal-body {
    max-height: calc(100vh - 190px);
  }
  @media screen and (max-aspect-ratio: 13/9) {
    #settlementInformationModal .modal-body {
      max-height: calc(100vh - 12em);
    }
  }
}
</style>



// WEBPACK FOOTER //
// SettlementInformationModal.vue?633057b7